<template>
  <div id="popup-install" class="py-5 px-10">
    <div id="popup-install" v-show="signaturePopup == true">
      <registration-popup @onClosedSignature="onClosedSignature" :passValue="passId"></registration-popup>
    </div>
    <div id="popup-install" v-show="signaturePopup == false">
      <h4>รายละเอียดการติดตั้งอุปกรณ์</h4>
      <vs-divider position="center"></vs-divider>
      <vs-row class="mt-5 ml-5">
        <div class="flex ml-5">
          <vs-radio
            disabled
            class="mr-5"
            v-model="checkbox"
            vs-value="chkPerson"
            >บุคคลธรรมดา</vs-radio
          >
          <vs-radio disabled class="mr-5" v-model="checkbox" vs-value="chkLegal"
            >นิติบุคคล</vs-radio
          >
          <vs-radio
            disabled
            class="mr-10"
            v-model="checkbox"
            vs-value="chkOther"
            >อื่นๆ โปรดระบุ</vs-radio
          >
          <p class="mt-2 mx-2" v-show="checkbox == 'chkOther'">ระบุ</p>
          <vs-input disabled class="w-auto" v-show="checkbox == 'chkOther'" />
        </div>

        <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
          <p>
            ชื่อ :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificateOperateName
                : `${info.title} ${info.firstName}  ${info.lastName}`
            }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
          <p>เลขบัตรประจำตัวประชาชน / เลขนิติบุคคล : {{ info.cardNumber }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>เลขรหัสประจำบ้าน : {{ info.houseCodeNumber }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ที่ตั้งสำนักงานใหญ่เลขที่ : {{ info.registrationOffice }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ชื่ออาคาร : {{ info.buildingName }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>เลขที่ : {{ info.address }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ชั้นที่ : {{ info.floor }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>
            อำเภอ/เขต :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificateDistrict
                : info.district
            }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>
            จังหวัด :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificateProvince
                : info.province
            }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>
            รหัสไปรษณีย์ :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificatePostalCode
                : info.postalCode
            }}
          </p>
        </vs-col>

        <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>
            โทรศัพท์ :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificatePhoneNumber
                : info.phoneNumber
            }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>
            อีเมล :
            {{
              info.personType == "นิติบุคคล"
                ? info.certificateEmail
                : info.email
            }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ชื่อเรือ : {{ vessel.name }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>หมายเลขทะเบียนเรือ : {{ vessel.registrationNumber }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ชื่อเรียกขาน (Call Sign) : {{ vessel.subName }}</p>
        </vs-col>

        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>วัสดุตัวเรือ : {{ vessel.material }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ขนาดเรือ ความยาวตลอดลําเมตร : {{ vessel.size }} เมตร</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ความกว้าง : {{ vessel.width }} เมตร</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ความลึก : {{ vessel.depth }} เมตร</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ตันกรอส : {{ vessel.tonGross }} ตันเนตชนิด</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ชนิดเครื่องจักร : {{ vessel.machineType }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>ชื่อเครื่อง : {{ vessel.machineName }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>จำนวนเครื่อง : {{ vessel.machineNumber }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="3" vs-sm="12" vs-xs="12">
          <p>จำนวนสูบ : {{ vessel.engineNumber }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>ขนาดเครื่องยนต์ : {{ vessel.engineSize }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="8" vs-sm="12" vs-xs="12">
          <p>
            ปริมารตรความจุถังน้ำมัน (ใช้สำหรับเรือ) : {{ vessel.capacity }} ลิตร
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
          <p>
            ปริมารตรความจุถังน้ำมัน (กรณีเรือบรรทุกน้ำมัน /
            เรือสถานีบริการจำหน่ายน้ำมัน) : {{ vessel.capacityForSale }} ลิตร
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ประเภทการใช้ : {{ vessel.usageType }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>
            ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวันที่ :
            {{ formateDate(vessel.licenseExpireDate) }}
          </p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>ประเภทเรือ : {{ vessel.vesselType }}</p>
        </vs-col>
        <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
          <p>หมดอายุวันที่ : {{ formateDate(vessel.expireDate) }}</p>
        </vs-col>
      </vs-row>

      <vs-row class="mt-5 w-full">
        <vs-divider />
      </vs-row>

      <h4 class="mb-5">ภาพรายละเอียดอุปกรณ์การติดตั้งอุปกรณ์</h4>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
          <div class="box" id="preview">
            <div v-if="vesselImage">
              <img :src="vesselImage" class="img-show" />
            </div>
            <div v-else>
              <img
                src="../../../assets/icons/cloud-img.png"
                width="200"
                height="200"
              />
            </div>
          </div>
          <div>
            <vs-button
              icon-pack="feather"
              icon="icon-upload"
              class="mt-10"
              color="primary"
              @click="$refs.onVesselImageChange.click()"
            >
              <span class="d-none d-sm-block">อัปโหลดรูป</span>
            </vs-button>
            <input
              ref="onVesselImageChange"
              type="file"
              accept=".jpeg,.png,.jpg,GIF"
              :hidden="true"
              @change="onVesselImageChange"
              v-validate="'required'"
              name="vessel_image"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('vessel_image')"
              >{{ errors.first("vessel_image") }}</span
            >
          </div>
          <h6 class="ml-5 mt-5">รูปที่ 1 ชื่อเรือ / เลขทะเบียนเรือ</h6>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
          <div class="box" id="preview">
            <div v-if="aisImage">
              <img :src="aisImage" class="img-show" />
            </div>
            <div v-else>
              <img
                src="../../../assets/icons/cloud-img.png"
                width="200"
                height="200"
              />
            </div>
          </div>
          <div>
            <vs-button
              icon-pack="feather"
              icon="icon-upload"
              class="mt-10"
              color="primary"
              @click="$refs.onAisImageChange.click()"
            >
              <span class="d-none d-sm-block">อัปโหลดรูป</span>
            </vs-button>
            <input
              ref="onAisImageChange"
              type="file"
              accept=".jpeg,.png,.jpg,GIF"
              :hidden="true"
              @change="onAisImageChange"
              v-validate="'required'"
              name="AIS_image"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('AIS_image')"
              >{{ errors.first("AIS_image") }}</span
            >
          </div>
          <h6 class="ml-5 mt-5">
            รูปที่ 2 อุปกรณ์ AIS Device
          </h6>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
          <div class="box" id="preview">
            <div v-if="vhfImage">
              <img :src="vhfImage" class="img-show" />
            </div>
            <div v-else>
              <img
                src="../../../assets/icons/cloud-img.png"
                width="200"
                height="200"
              />
            </div>
          </div>
          <div>
            <vs-button
              icon-pack="feather"
              icon="icon-upload"
              class="mt-10"
              color="primary"
              @click="$refs.onVhfImageChange.click()"
            >
              <span class="d-none d-sm-block">อัปโหลดรูป</span>
            </vs-button>
            <input
              ref="onVhfImageChange"
              type="file"
              accept=".jpeg,.png,.jpg,GIF"
              :hidden="true"
              @change="onVhfImageChange"
              v-validate="'required'"
              name="VHF_image"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('VHF_image')"
              >{{ errors.first("VHF_image") }}</span
            >
          </div>
          <h6 class="ml-5 mt-5">รูปที่ 3 อุปกรณ์ VHF Antenna</h6>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-5 mt-10" align="center">
          <div class="box" id="preview">
            <div v-if="gpsImage">
              <img :src="gpsImage" class="img-show" />
            </div>
            <div v-else>
              <img
                src="../../../assets/icons/cloud-img.png"
                width="200"
                height="200"
              />
            </div>
          </div>
          <div>
            <vs-button
              icon-pack="feather"
              icon="icon-upload"
              class="mt-10"
              color="primary"
              @click="$refs.onGpsImageChange.click()"
            >
              <span class="d-none d-sm-block">อัปโหลดรูป</span>
            </vs-button>
            <input
              ref="onGpsImageChange"
              type="file"
              accept=".jpeg,.png,.jpg,GIF"
              :hidden="true"
              @change="onGpsImageChange"
              v-validate="'required'"
              name="GPS_image"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('GPS_image')"
              >{{ errors.first("GPS_image") }}</span
            >
          </div>
          <h6 class="ml-5 mt-5">รูปที่ 4 อุปกรณ์ GPS Antenna</h6>
        </div>
      </div>

      <vs-row class="mt-5 w-full">
        <vs-divider />
      </vs-row>

      <h4 class="mb-5 px-1 flex">อัปโหลดเอกสารเพื่อเป็นหลักฐาน</h4>
      <div class="vx-row mt-10 mx-auto">
        <div class="vx-col w-full" align="center">
          <div
            v-if="documentFiles.length != 0"
            class="demo-alignment px-20 flex content-center justify-center"
          >
            <div v-for="(item, index) in documentFiles" :key="index">
              <vs-chip @click="remove(index)" closable>
                <vs-avatar
                  v-if="item.type == 'application/pdf'"
                  icon-pack="feather"
                  icon="icon-file"
                  class="m-3"
                  style="height: 30px; width: 30px"
                />
                <!-- <vs-avatar v-else :src="documentFilesURL[index]" align="center" class="h-24 min-h-full w-24 max-w-full" /> -->
                <img
                  v-else
                  :src="documentFilesURL[index]"
                  class="m-3"
                  style="height: 100px; max-width: 150px"
                />
                <span>{{ item.name }} </span>
              </vs-chip>
            </div>
          </div>
          <div v-else class="box" id="preview">
            <img
              src="../../../assets/icons/cloud-img.png"
              width="200"
              height="200"
            />
          </div>
          <div>
            <vs-button
              icon-pack="feather"
              icon="icon-upload"
              class="mt-10"
              color="primary"
              @click="$refs.onChangeFiles.click()"
            >
              <span class="d-none d-sm-block">อัปโหลดรูป</span>
            </vs-button>
            <input
              ref="onChangeFiles"
              type="file"
              accept=".jpeg,.png,.jpg,.GIF,.pdf"
              :hidden="true"
              @change="onChangeFiles"
              v-validate="'required'"
              name="files"
              multiple="multiple"
            />
            <span class="text-danger text-sm" v-show="errors.has('files')">{{
              errors.first("files")
            }}</span>
          </div>
          <h6 class="mt-5">อัปโหลดเอกสารการติดตั้งอุปกรณ์</h6>
          <p class="mt-2" style="color: gray; font-size: 12px">
            *อัปโหลดได้ไม่เกิน 5 ไฟล์
          </p>
        </div>
      </div>

      <div class="content-block">
        <div class="mx-20 mt-20 mb-20">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ข้าพเจ้าขอรับรองว่าข้อความในแบบคำขอที่ยื่นมานี้มีความถูกต้องและเป็นจริงทุกประการ
            ตลอดจนจะปฏิบัติตามกฎหมายและระเบียบของทางราชการทุกประการ
            และเมื่อได้รับการติดตั้งอุปกรณ์ระบบสำแดงข้อมูลตัวตนอัตโนมัติ
            (Automatic Identification System : AIS) จากกรมสรรพสามิตแล้ว
            ข้าพเจ้าจะดูแลรักษาอุปกรณ์ระบบฯ ดังกล่าวเป็นอย่างดี
            และหากเกิดการชำรุดเสียหายอันเกิดจากความประมาทเลินเล่อในการปฏิบัติงาน
            ข้าพเจ้ายินยอมชดใช้ค่าเสียหายและค่าซ่อมแซมอุปกรณ์ระบบฯ
            ให้แก่กรมสรรพสามิต
          </p>
        </div>

        <vs-row class="mb-10">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-10"
            v-if="companySealImage"
          >
            <img :src="companySealImage" height="100" />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <img
              :src="this.imageSignatureAdminUrl"
              width="25%"
              v-if="imageSignatureAdminUrl"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
          >
            <span class="flex">
              <p>ลงชื่อ</p>
              <p>
                ........................................................................
              </p>
              <p>(ผู้ติดตั้งอุปกรณ์)</p>
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>({{user.username == 'admin' ? 'บริษัท เปรม กรุ๊ป เอ็นจิเนียริ่ง จำกัด' : ` ${user.title || ''}${user.firstName || dot} ${user.lastName || ''} `}})</p>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="mt-5"
          >
            <p>วันที่ {{ formateDate(new Date()) }}</p>
          </vs-col>
        </vs-row>
      </div>

      <div align="center" class="my-5">
        <vs-button type="filled" @click.prevent="submitForm" class="mt-5 mr-5"
          >ยืนยันการติดตั้งอุปกรณ์</vs-button
        >
        <vs-button color="danger" type="border" @click="()=> this.$emit('onClosedInstall', false)">ย้อนกลับ</vs-button>
      </div>
    </div>

  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Validator } from "vee-validate";
import { INSTALL_ACCESSOIRES } from "../../../mock-data/form-validate.js";
import moment from "moment";
import RegistrationPopup from "../registration-popup/RegistrationPopup.vue"

import { ENDPOINT } from "../../../constants/endpoint";

// register custom messages
Validator.localize("en", INSTALL_ACCESSOIRES);

export default {
  props: {
    dataVessel: Object,
  },
  components: {
    RegistrationPopup,
    
  },
  data() {
    return {
      isComfirm: false,
      url: null,
      info: {},
      vessel: {},
      checkbox: null,
      vesselImage: null,
      aisImage: null,
      vhfImage: null,
      gpsImage: null,
      vesselImageFile: null,
      aisImageFile: null,
      vhfImageFile: null,
      gpsImageFile: null,
      documentFiles: [],
      documentFilesURL: [],
      registrationAt: null,
      vesselSignature: null,
      imageSignatureUserUrl: null,
      imageSignatureSupervisorUrl: null,
      imageSignatureObserverUrl: null,
      imageSignatureAdminUrl: null,
      companySealImage: null,
      signaturePopup: false,
      passId:null,
      user: null,
      dot: '........................................................................'
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      // console.log("this.dataVessel ", this.dataVessel);
      await this.$store.dispatch(
        `vessels/setVesselById`,
        this.dataVessel.registrationId
      );
      this.info = this.$store.state.vessels.vessel.registration.createdBy;
      // console.log("this is infomation :", this.info);
      this.vessel = this.$store.state.vessels.vessel.vessel;

      this.vesselSignature = await this.$store.state.vessels.vessel;
      this.registrationAt = await this.vesselSignature.registration.createdAt;

      // console.log("this is signature :", this.vesselSignature);
      // console.log("this is registrationAt :", this.registrationAt);

      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });

      this.user = await this.$store.state.users.user;
      console.log("this is user ===> ", this.user);
      this.imageSignatureAdminUrl = this.user.signatureName
        ? ENDPOINT.GET_IMAGE_SIGNATURE + this.user.signatureName
        : "";

      this.info.personType == "บุคคลทั่วไป"
        ? (this.checkbox = "chkPerson")
        : this.info.personType == "นิติบุคคล"
        ? (this.checkbox = "chkLegal")
        : (this.checkbox = "chkOther");

      if (this.vesselSignature.installations[0].signatures.lenght != 0) {
        for (const signature of this.vesselSignature.installations[0]
          .signatures) {
          if (signature.type == "ผู้ยื่นคำขอ") {
            this.imageSignatureUserUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          // if(signature.type == "ผู้ดูแลระบบ"){
          //   this.imageSignatureAdminUrl =
          //     ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          // }
          if (signature.type == "เจ้าพนักงานสรรพสามิต") {
            this.imageSignatureSupervisorUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
          if (signature.type == "ผู้บริหาร") {
            this.imageSignatureObserverUrl =
              ENDPOINT.GET_IMAGE_SIGNATURE + signature.fileName;
          }
        }
      }
    },
    async submitForm() {
      await this.$store.dispatch("users/setUserById", {
        id: localStorage.getItem("accessUserId"),
      });
      const user = await this.$store.state.users.user;

      console.log("this is user ===> ", user.signatureName);

      this.$validator.validateAll().then((result) => {
        if (result) {
          if (user.signatureName != "" && user.signatureName != null) {
          // if form have no errors
          const data = {
            installationId: this.dataVessel.installId,
            imgNameVessel: this.vesselImageFile,
            imgAIS: this.aisImageFile,
            imgVHF: this.vhfImageFile,
            imgGPS: this.gpsImageFile,
            fileName: user.signatureName,
          };
          this.$store
            .dispatch("accessories/installAccessories", {
              data,
              documents: this.documentFiles,
            })
            .then(() => {
              const error = this.$store.state.accessories.error;
              if (error) {
                Swal.fire({
                  target: document.getElementById("popup-install"),
                  icon: "error",
                  title: "ข้อมูลไม่ถูกต้อง",
                  text: "กรุณาตรวจสอบข้อมูลอีกครั้ง",
                  showConfirmButton: false,
                  timer: 2500,
                });
              } else {
                Swal.fire({
                  target: document.getElementById("popup-install"),
                  icon: "success",
                  title: "สำเร็จ",
                  text: "ติดตั้งอุปกรณ์เรียบร้อยแล้ว",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  // this.$emit("onClosedInstall", false);
                  // this.$emit("onClosedPopupInstall", false);
                  location.reload();
                });
              }
            });          
          } else {
            const id = this.$store.state.vessels.vessel.installations[0].id;
            const data = {
                installationId: this.dataVessel.installId,
                imgNameVessel: this.vesselImageFile,
                imgAIS: this.aisImageFile,
                imgVHF: this.vhfImageFile,
                imgGPS: this.gpsImageFile,
              };
            const payload = {
              data,
              documents: this.documentFiles,
              fileName: user.signatureName,
            }
            this.passId = {id ,name: "ยืนยันการติดตั้งอุปกรณ์", type:"install_admin" , data: payload};
            console.log("this is passId :", this.passId);
            this.signaturePopup = !this.signaturePopup;
          }
        } else {
          // form have errors
          Swal.fire({
            target: document.getElementById("popup-install"),
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
          });
        }
      });
    },
    onVesselImageChange(e) {
      const file = e.target.files[0];
      this.vesselImage = URL.createObjectURL(file);
      this.vesselImageFile = file;
    },
    onAisImageChange(e) {
      const file = e.target.files[0];
      this.aisImage = URL.createObjectURL(file);
      this.aisImageFile = file;
    },
    onVhfImageChange(e) {
      const file = e.target.files[0];
      this.vhfImage = URL.createObjectURL(file);
      this.vhfImageFile = file;
    },
    onGpsImageChange(e) {
      const file = e.target.files[0];
      this.gpsImage = URL.createObjectURL(file);
      this.gpsImageFile = file;
    },
    formateDate(date) {
      return date && moment(date).add(543, "year").format("DD/MM/YYYY");
    },
    onChangeFiles(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.documentFiles = [];
      this.documentFilesURL = [];

      if (files.length > 5) {
        Swal.fire({
          target: document.getElementById("popup-install"),
          icon: "warning",
          title: "ไฟล์มีจำนวนเกินที่กำหนด",
          text: "กรุณาอัปโหลดไฟล์ไม่เกิน 5 ไฟล์",
          showConfirmButton: false,
          timer: 1500,
        });
      }else{
        for (const item of e.target.files) {
          this.documentFiles.push(item);
          const url = URL.createObjectURL(item);
          this.documentFilesURL.push(url);
        }
      }
    },
    remove(index) {
      this.documentFiles.splice(index, 1);
      this.documentFilesURL.splice(index, 1);
    },
    onClosedSignature(val) {
      this.signaturePopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  max-width: 370px;
  height: 225px;
}
</style>
